import { render, staticRenderFns } from "./BdMobileBox.vue?vue&type=template&id=703f3d1a&scoped=true"
import script from "./BdMobileBox.vue?vue&type=script&lang=js"
export * from "./BdMobileBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f3d1a",
  null
  
)

export default component.exports